import React, { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { Collapse, List, ListItemButton } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useQuery } from "react-query";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { flatten } from "lodash";
import { cityBasedWarehouseFn } from "../../../Services/Authentication/CityBasedWarehouse";
import { ArrowBack } from "@mui/icons-material";
import SearchModal from "../../../Shared/Search";
import WishlistButton from "../../../Shared/WishlistButton";
import Checkout from "../../Checkout";
import { useNavigate } from "react-router-dom";

const StoreLocation = () => {
  const [collapse, setCollapse] = useState([]);
  const [collapse2, setCollapse2] = useState([]);
  const navigate = useNavigate();
  const apiKey = "AIzaSyAO3TRgzZx5X3i6tTcuNMjCvvCxhWe4M3g";
  const libraries = ["places"];
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };
  const handleClick = (id) => {
    setCollapse((collapse) => [...collapse, id]);
  };
  const handleClose = (id) => {
    setCollapse(collapse?.filter((item) => item !== id));
  };

  const handleClick2 = (id) => {
    setCollapse2((collapse) => [...collapse, id]);
  };
  const handleClose2 = (id) => {
    setCollapse2(collapse2?.filter((item) => item !== id));
  };

  const { data: warehouse } = useQuery(
    ["warehouse"],
    () => cityBasedWarehouseFn(),
    {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    }
  );

  const stores = flatten(
    warehouse?.data?.country_data?.map((i) =>
      flatten(i.city_list?.map((i2) => i2.stores))
    )
  );

  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl">My Wishlist</p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>
      <div className="flex pt-16 flex-col w-full">
        <Carousel autoPlay={true} transitionTime={3} showThumbs={false}>
          <div>
            <img
              src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/store-locator1.webp"
              alt=""
            />
          </div>
          <div>
            <img
              alt=""
              src="https://pub-8de1a28f49c04a568b19557f02b6129b.r2.dev/Assets/store-locator2.webp"
            />
          </div>
        </Carousel>

        <div className="flex flex-col items-center py-5 w-full">
          <p className="lg:text-4xl text-2xl font-semibold py-3">
            Retail Stores
          </p>

          <div className="flex lg:flex-row flex-col w-full gap-2 bg-gray-100 lg:p-5 p-2 lg:px-[8%]">
            <List className="bg-white lg:w-1/5 !p-1">
              {warehouse?.data?.country_data?.map((city, index) => {
                return (
                  <>
                    <ListItemButton
                      onClick={() => {
                        collapse.indexOf(city.country) === -1
                          ? handleClick(city.country)
                          : handleClose(city.country);
                      }}
                      className="!flex !justify-between !rounded hover:!bg-gray-200 !w-full"
                    >
                      <span className="flex flex-col gap-1">
                        <span className="font-semibold">{city.country}</span>
                      </span>

                      {collapse.indexOf(city.country) !== -1 ? (
                        <ExpandMore fontSize="large" />
                      ) : (
                        <ExpandLess fontSize="large" />
                      )}
                    </ListItemButton>
                    <Collapse
                      in={collapse.indexOf(city.country) !== -1}
                      className="bg-gray-100"
                    >
                      {city?.city_list?.map((store) => {
                        return (
                          <>
                            <ListItemButton
                              className="!flex !pl-8 !justify-between !rounded !w-full"
                              onClick={() => {
                                collapse2.indexOf(store.city) === -1
                                  ? handleClick2(store.city)
                                  : handleClose2(store.city);
                              }}
                            >
                              {store.city}
                              {collapse2.indexOf(store.city) !== -1 ? (
                                <ExpandMore fontSize="large" />
                              ) : (
                                <ExpandLess fontSize="large" />
                              )}
                            </ListItemButton>
                            <Collapse
                              in={collapse2.indexOf(store.city) !== -1}
                              className="bg-gray-200"
                            >
                              {store.stores?.map((item) => {
                                return (
                                  <ListItemButton className="!flex !pl-12 !justify-between !rounded !w-full">
                                    {item.name}
                                  </ListItemButton>
                                );
                              })}
                            </Collapse>
                          </>
                        );
                      })}
                    </Collapse>
                  </>
                );
              })}
            </List>

            <div className="lg:w-4/5 w-full h-[600px] bg-blue-100 pb-10">
              <LoadScript libraries={libraries} googleMapsApiKey={apiKey}>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={{
                    lat: stores?.[0]?.store?.latitude || 26.8467,
                    lng: stores?.[0]?.store?.longitude || 80.9462,
                  }}
                  zoom={5}
                >
                  {stores?.map((store, index) => {
                    return (
                      <Marker
                        key={index}
                        position={{
                          lat: Number(store.latitude),
                          lng: Number(store.longitude),
                        }}
                        label={store.name}
                      />
                    );
                  })}
                </GoogleMap>
              </LoadScript>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreLocation;
